export default __webpack_public_path__ + "static/media/wb-1.068d4c4e.jpg";